// Standalone dispatch „otevři detail objektu dle ObjectCategory + ID" — bez React kontextu
// bridge (volá se z `MenuNavigationShellPage`). Magic generický `form/edit` handler přeloží
// ObjectCategory na editační formulář a probublá zpět jako `form/open` → bridge otevře agendu
// (respektuje `pendingMenuOpen` pro replace/detached). Cílí na Magic desktop přes `getMagicDesktopFrame()`.

import { getMagicDesktopFrame } from '@/shared/lib/legacyMagic';
import { PHOENIX_TO_MAGIC_ACTIONS } from './types';

/**
 * Otevři legacy detail agendy pro `objectCategory` (např. `BusinessCase`) s daným `id`.
 * Magic si sám dohledá editační formulář i parametr `ID`.
 */
export function sendMagicFormEdit(objectCategory: string, id: number): void {
  const frame = getMagicDesktopFrame();
  if (!frame) return;
  frame.postMessage(
    {
      action: PHOENIX_TO_MAGIC_ACTIONS.formEdit,
      data: { ObjectCategory: objectCategory, ID: id },
      requestId: crypto.randomUUID(),
    },
    '*'
  );
}
